export const appDemos = [
  {
    id: "greenshowtime",
    title: "GreenShowTime",
    category: "Entertainment discovery",
    description: "Discover movies, series and anime, explore recommendations, and find where to watch. A platform bringing watchlists and streaming availability together.",
    status: "In development",
    statusKey: "development",
    url: "https://www.greenshowtime.com/",
    preview: {
      desktop: "/projects/greenshowtime.webp",
      desktopHeight: 1000,
      mobile: "/projects/greenshowtime-mobile.webp",
      label: "Website preview"
    }
  },
  {
    id: "quinta-do-lameiro",
    title: "Quinta do Lameiro",
    category: "Hospitality website",
    description: "A website for Quinta do Lameiro, presenting its bungalows, surroundings and stay availability. Currently in development, with a demo of the booking experience.",
    status: "In development",
    statusKey: "development",
    url: "https://quintadolameiro-production.up.railway.app/",
    preview: {
      desktop: "/projects/quinta-do-lameiro.webp",
      desktopHeight: 4232,
      mobile: "/projects/quinta-do-lameiro-mobile.webp",
      label: "Demo preview"
    }
  },
  {
    id: "genki-douro",
    title: "Genki Douro",
    category: "Restaurant website",
    description: "A website for Genki Douro in Vila Real, featuring an interactive menu, a gallery, and reservation information. Built to help visitors explore the restaurant before their visit.",
    status: "Completed",
    statusKey: "completed",
    url: "https://genkidouro.com/",
    preview: {
      desktop: "/projects/genki-douro.webp",
      desktopHeight: 1000,
      mobile: "/projects/genki-mobile.webp",
      label: "Website preview"
    }
  }
];

export const projects = [
  {
    id: 1,
    title: "Brain Computer Interface Platform",
    description: "A bachelor's final project exploring games controlled through EEG signals. Built in Python, the platform processes real-time signals and maps focus and attention metrics to in-game actions.",
    stack: ["Python", "Neurosky Mindwave", "Signal Processing", "EEG"],
    links: {
      github: "",
      demo: ""
    }
  },
  {
    id: 2,
    title: "Rugby Team Web Platform",
    description: "A responsive community platform bringing team information, match updates and a media gallery together. Designed to keep players and supporters connected across desktop and mobile.",
    stack: ["React", "Node.js", "Firebase"],
    links: {
      github: "",
      demo: ""
    }
  },
  {
    id: 3,
    title: "API Gateway for A-MoVeR",
    description: "A custom API Gateway for the A-MoVeR mobility ecosystem. Integrates microservices through REST and gRPC, centralizes authentication with Keycloak, and provides real-time visibility into service communication.",
    stack: ["Go", "React", "Keycloak", "Docker", "gRPC", "REST API"],
    links: {
      github: "",
      demo: ""
    }
  }
];

export const experience = [
  {
    id: 3,
    position: "System & Cybersecurity Engineer",
    organization: "CGI · Space · IRIS²",
    period: "1 April 2026 – Present",
    current: true,
    description: "Working in CGI's space sector on the IRIS² project, bringing my background in systems integration and software engineering into systems and cybersecurity engineering.",
    fullDescription: `Since 1 April 2026, I have worked at CGI in the space sector on the IRIS² project as a System & Cybersecurity Engineer. I am based in Rotterdam, the Netherlands.

This role builds on my experience in distributed systems, API design, authentication and DevOps. It marks the next step in my career, connecting that software and systems foundation with a focus on systems engineering and cybersecurity in the space sector.`,
    skillsDeveloped: [
      "Systems engineering",
      "Cybersecurity engineering",
      "Space-sector engineering",
      "Systems integration & security-aware design"
    ]
  },
  {
    id: 1,
    position: "Researcher – Systems Integration",
    organization: "A-MoVeR R&D Project · University of Trás-os-Montes e Alto Douro",
    period: "2024 - 2026",
    description: "Developed systems integration solutions for intelligent electric mobility, combining backend development, API architecture and infrastructure management in the A-MoVeR R&D project.",
    fullDescription: `As part of the Systems Management & Integration team in A-MoVeR, I worked on a national R&D project focused on intelligent electric mobility. My role combined backend development, system design and infrastructure management across a distributed ecosystem of microservices.

I designed and implemented the A-MoVeR API Gateway, integrating Keycloak-based authentication, supporting both gRPC and REST communication, and contributing to architectural decisions involving telemetry flows, data pipelines and cloud-native development. I also delivered a Docker training workshop for the academic community, supporting DevOps adoption and development environment standardization.

I also co-authored research with INESC TEC on the design and implementation of a Digital Twin for intelligent electric mobility. This experience connected practical engineering with research, technical writing and collaboration across academic and industry teams.`,
    skillsDeveloped: [
      "Systems integration & distributed architectures",
      "API design (REST, gRPC) & authentication with Keycloak",
      "Backend engineering (Go) & frontend tooling (React)",
      "Linux server management & DevOps workflows",
      "Docker, containerization & development environments",
      "Research, technical writing & experimental validation",
      "Collaboration within a national R&D ecosystem"
    ]
  },
  {
    id: 2,
    position: "Vice-President – Informatics Engineering Students Association",
    organization: "NEEI UTAD",
    period: "2023",
    description: "Served as Vice-President of the Informatics Engineering Students Association, helping coordinate academic initiatives, technical events and community engagement activities.",
    fullDescription: `Served as Vice-President of the Informatics Engineering Students Association, helping coordinate academic initiatives, technical events and community engagement activities. I worked closely with teams to organize workshops, hackathons, integration events and student support programmes, while ensuring smooth communication between students, faculty and industry partners.

This role strengthened my leadership, organisation and people-management abilities, and allowed me to contribute directly to the growth of the student tech community at UTAD.`,
    skillsDeveloped: [
      "Team leadership & decision-making",
      "Event planning, coordination & execution",
      "Communication and stakeholder management",
      "Community-building & student engagement",
      "Organisation, delegation & time management",
      "Collaboration in multidisciplinary teams"
    ]
  }
];

export const education = [
  {
    id: 1,
    degree: "Master's Degree in Informatics Engineering",
    institution: "UTAD - University of Trás-os-Montes and Alto Douro",
    period: "2023 - 2026",
    details: "Dissertation: API Gateway for the A-MoVeR Ecosystem",
    fullDescription: `The master's programme deepens the bachelor's foundations with strong emphasis on software architecture, systems integration, distributed systems, and engineering best practices. Core subjects explored advanced design patterns, system modelling, operations research, web technologies, project management and innovation.

Complementary modules such as Cryptography & System Security, Digital Game Development, Virtual Reality and Low-Code Web Tools expanded my technical versatility, strengthening both secure development skills and the ability to design interactive, immersive and rapid-prototyping solutions.

Overall, the programme bridges theory with real-world practice, preparing me to design scalable, maintainable and secure software systems suited for demanding engineering environments.`,
    dissertation: {
      title: "API Gateway for the A-MoVeR Mobility Ecosystem",
      description: `My dissertation addressed the challenge of integrating heterogeneous services in A-MoVeR, a national R&D initiative focused on intelligent electric mobility.
I designed and implemented a custom API Gateway in Go, supported by a React administrative dashboard, enabling:

• Dynamic endpoint & service management
• Distributed service discovery
• Centralized authentication & authorization with Keycloak
• Traffic control policies (rate limiting, retries, timeouts, circuit breaking)
• Real-time observability dashboards and telemetry streaming
• An integrated API testing hub for inspection and debugging

The solution improved communication stability, reduced latency variability and simplified operational governance across the ecosystem's microservices.`
    },
    skillsDeveloped: [
      {
        category: "Software Engineering & Architecture",
        skills: ["Software architecture, design patterns & system modelling", "Microservices, distributed systems & API gateway design", "Scalable and maintainable system design"]
      },
      {
        category: "Cybersecurity & Cryptography",
        skills: ["Secure software development practices", "Authentication & access control with Keycloak", "Cryptographic fundamentals & security-aware engineering"]
      },
      {
        category: "Full-Stack & Application Development",
        skills: ["Go backend development", "React frontend engineering", "Building interactive systems (games, VR prototypes)", "Rapid development with low-code web tools"]
      },
      {
        category: "DevOps & Operations",
        skills: ["Docker containerization", "CI/CD pipelines & environment management", "Observability, metrics, telemetry & system monitoring"]
      },
      {
        category: "Research & Professional Skills",
        skills: ["Scientific writing & technical documentation", "Experimental validation & research methodology", "Innovation-driven problem solving", "Collaboration within multidisciplinary R&D teams"]
      }
    ]
  },
  {
    id: 2,
    degree: "Bachelor's Degree in Informatics Engineering",
    institution: "UTAD - University of Trás-os-Montes and Alto Douro",
    period: "2020 - 2024",
    details: "Foundation in computer science, programming, and software development.",
    fullDescription: `This degree established a strong foundation in computer science, mathematics and software engineering. The curriculum combined rigorous theoretical learning with extensive hands-on programming in C, C++, C#, MATLAB and Python. Core subjects included algorithms, data structures, operating systems, compilers, computer architecture, databases, networks, distributed systems and web engineering.

Alongside the technical training, it developed structured problem-solving abilities, engineering reasoning and professional development practices.`,
    skillsDeveloped: [
      {
        category: "Core Skills",
        skills: [
          "Algorithmic and mathematical reasoning",
          "Procedural, object-oriented and functional programming",
          "Operating systems, compilers & low-level computing concepts",
          "Database design & data modelling",
          "Software engineering fundamentals",
          "System design & architectural thinking",
          "Teamwork through lab-based engineering projects"
        ]
      }
    ]
  }
];

export const certifications = [
  {
    id: 1,
    name: "European Innovation Academy – Entrepreneurship & Innovation",
    issuer: "European Innovation Academy",
    year: "2023",
    description: "International programme focused on transforming ideas into startup-ready products.",
    fullDescription: `A three-week intensive, international programme focused on transforming ideas into startup-ready products. Working in a multidisciplinary team, I engaged in customer validation, problem definition, value proposition design, prototyping, business modelling and investor pitching.

The programme emphasized fast experimentation, market-driven thinking and execution in high-pressure environments, guided by entrepreneurs and industry mentors.`,
    skillsDeveloped: [
      "Entrepreneurship & innovation mindset",
      "Product design, customer discovery & validation",
      "Business strategy & model development",
      "Pitching, storytelling & communication",
      "Cross-functional collaboration",
      "Rapid prototyping & iterative development"
    ]
  },
  {
    id: 2,
    name: "English C2 Proficiency – EF London & EFSET",
    issuer: "EF Education First",
    year: "2024",
    description: "C2 Proficiency, the highest level in the CEFR.",
    fullDescription: `Achieved C2 Proficiency, the highest level in the CEFR, through intensive study at EF London and confirmed by the EFSET certification. This level demonstrates the ability to understand complex academic, technical and professional content, communicate fluently and precisely, and write clear and structured documents across various contexts.`,
    skillsDeveloped: [
      "Advanced professional and academic communication",
      "Fluent technical English for engineering contexts",
      "Clear and structured writing (reports, documentation, research)",
      "Confident presentations and public speaking",
      "Cross-cultural competence in international settings"
    ]
  }
];

export const hobbies = [
  {
    id: 1,
    title: "🏉 Rugby",
    description: "Rugby has been an important part of my life, including playing for GRUFC and AAUTAD in Portugal. I value the teamwork, discipline and shared commitment that the sport develops."
  },
  {
    id: 2,
    title: "🎮 Online Gaming",
    description: "Playing online games with friends like CS2, enjoying the competitive gameplay and team coordination."
  },
  {
    id: 3,
    title: "♟️ Chess",
    description: "Enjoying strategic thinking and problem-solving through chess games."
  },
  {
    id: 4,
    title: "💪 Gym & Fitness",
    description: "Regular gym training to maintain physical health and mental well-being."
  },
  {
    id: 5,
    title: "📺 Anime, Series & Movies",
    description: "Watching anime, series and movies in my free time to relax and explore different stories."
  },
  {
    id: 6,
    title: "🌍 Tech Volunteering",
    description: "Participating in programming events to teach young people and promote technology education."
  },
  {
    id: 7,
    title: "📚 Continuous Learning",
    description: "Always exploring new technologies, frameworks, and best practices in software development."
  }
];
